/*!

=========================================================
* Argon Dashboard React - v1.2.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import { RouteItem, UserPermissions } from "./types";
import CurrentExecutions from "./views/CurrentExecutions";
import ExecutionInfo from "./views/ExecutionInfo";
import HistoricalExecutions from "./views/HistoricalExecutions";
// import Index from "./views/Index";
import Login from "./views/Login";
import SchedulerTrigger from "./views/SchedulerTrigger";
import SchedulerVideo from "./views/SchedulerVideo";
import Users from "./views/Users";
import EarningsCall from "./views/EarningsCall";
import Transcript from "./views/Transcript";
import HistoricalAnalysis from "./views/HistoricalAnalysis";
import EarningsConversation from "./views/EarningsConversation";

const routes: RouteItem[] = [
  // {
  //   path: "/index",
  //   name: "Chemical Database",
  //   icon: "fas fa-search text-primary",
  //   component: Index,
  //   layout: "/admin",
  //   isSidebarItem: true,
  // },
  {
    path: "/monitor",
    name: "Current Executions",
    icon: "fas fa-satellite-dish text-primary",
    component: CurrentExecutions,
    layout: "/admin",
    isSidebarItem: true,
  },
  {
    path: "/execution/:id",
    name: "Execution",
    icon: "",
    component: ExecutionInfo,
    layout: "/admin",
    isSidebarItem: false,
  },
  {
    path: "/historicalExecutions",
    name: "Past Executions",
    icon: "fas fa-history text-primary",
    component: HistoricalExecutions,
    layout: "/admin",
    isSidebarItem: true,
  },
  // {
  //   path: "/config",
  //   name: "Website Configuration",
  //   icon: "fas fa-cogs text-primary",
  //   component: Configuration,
  //   layout: "/admin",
  //   isSidebarItem: true,
  //   // allow: [UserPermissions.admin, UserPermissions.read, UserPermissions.write],
  // },
  // {
  //   path: "/chemical/:id",
  //   name: "Chemical Information",
  //   icon: "ni ni-single-copy-04 text-primary",
  //   component: ChemicalInfo,
  //   layout: "/admin",
  //   isSidebarItem: false,
  // },
  {
    path: "/scheduler/video",
    name: "Analyse Video/Audio",
    icon: "fas fa-video text-primary",
    component: SchedulerVideo,
    layout: "/admin",
    isSidebarItem: true,
    allow: [UserPermissions.write],
  },
  // {
  //   path: "/scheduler/trigger",
  //   name: "Trigger Conference",
  //   icon: "ni ni-calendar-grid-58 text-primary",
  //   component: SchedulerTrigger,
  //   layout: "/admin",
  //   isSidebarItem: true,
  //   allow: [UserPermissions.write],
  // },
  // {
  //   path: "/reports",
  //   name: "Reports",
  //   icon: "ni ni-world-2 text-primary",
  //   component: Reports,
  //   layout: "/admin",
  //   isSidebarItem: true,
  // },
  {
    path: "/login",
    name: "Login",
    icon: "ni ni-key-25 text-info",
    component: Login,
    layout: "/auth",
    isSidebarItem: false,
  },
  {
    path: "/users",
    name: "Users",
    icon: "ni ni-circle-08 text-primary",
    component: Users,
    layout: "/admin",
    isSidebarItem: true,
    allow: [UserPermissions.admin],
  },
  {
    path: "/earningsCall/transcriptsList",
    name: "Earnings Call",
    icon: "fas fa-chart-line text-primary",
    component: EarningsCall,
    layout: "/admin",
    isSidebarItem: false,
  },
  {
    path: "/earningsCall/transcript",
    name: "Events List",
    icon: "fas fa-history text-primary",
    component: Transcript,
    layout: "/admin",
    isSidebarItem: false,
  },
  {
    path: "/earningsCall/historicalAnalysis",
    name: "Historical Analysis",
    icon: "fas fa-history text-primary",
    component: HistoricalAnalysis,
    layout: "/admin",
    isSidebarItem: false,
  },
  {
    path: "/earningsCall/conversation",
    name: "Historical Analysis",
    icon: "fas fa-history text-primary",
    component: EarningsConversation,
    layout: "/admin",
    isSidebarItem: false,
  },
];
export default routes;
